export default __webpack_public_path__ + "dfe47115f9f63c8a85e501c53c7cf612.png";